module.exports = __webpack_public_path__ + "main.jpg?7dc26f4e3066bf10e76b943222cda19f";